<template>
  <div>
    <div class="card mb-5 mb-3">
      <div class="card-header">
        <h3 class="card-title flex-row"><i class="fa fa-list"></i> <span class="card-label fs-3 ms-1">Quản lý
            Phản ánh hiện trường</span></h3>
      </div>
      <div class="card-body">
        <el-row :gutter="10">
          <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
            <label>Họ và tên:</label>
            <el-row :gutter="10">
              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <el-input clearable placeholder="Họ và tên..." v-model="search.cHoVaTen" />
              </el-col>
            </el-row>
          </el-col>
          <!-- <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
            <label>Mô tả:</label>
            <el-row :gutter="10">
              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <el-input clearable placeholder="Mô tả..." v-model="search.cMoTa" />
              </el-col>
            </el-row>
          </el-col> -->
          <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
            <label>Trạng thái:</label>
            <el-row :gutter="10">
              <el-col :xs="20" :sm="22" :md="20" :lg="20" :xl="22">
                <el-select placeholder="Tất cả" v-model="search.nTrangThai">
                  <el-option label="Tất cả" value="" selected></el-option>
                  <el-option label="Đã phản hồi" value="2" selected></el-option>
                  <el-option label="Chưa phản hồi" value="1" selected></el-option>
                  <el-option label="Đã xóa" value="0" selected></el-option>
                </el-select>
              </el-col>
              <el-col :xs="4" :sm="2" :md="4" :lg="4" :xl="2">
                <el-button plain type="primary" title="Tìm kiếm" @click="handleFindPage"><i
                    class="fa fa-search"></i></el-button>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </div>
    </div>

    <div class="card data-table mb-5 mb-xl-10">
      <div class="card-header py-3">
        <div class="body-function">
          <div class="col-md-6">
            <!-- <el-button plain type="primary" outline native-type="submit" @click="handleOpenAdd" data-bs-toggle="modal"
              data-bs-target="#modal_news">
              <span class="btn-inner--icon"><i class="fas fa-plus"></i></span>
              <span class="btn-inner--text">&nbsp;Thêm phản hồi</span>
            </el-button> -->
          </div>
          <!-- <div class="col-md-6" style="text-align:right">
              <el-button plain icon="el-icon-refresh" size="small" style="margin-right:30px" title="Đồng bộ" type="warning" @click=""
                v-loading.fullscreen.lock="isLoading"></el-button>
            </div> -->
        </div>
      </div>
      <div class="card-body">
        <div class="col-md-12 tbl">
          <el-table :data="tableData.content" header-row-class-name="thead-light" style="height: 100%" height="100%" fit
            stripe highlight-current-row>
            <el-table-column prop="bAnDanh" show-overflow-tooltip class="text-nowrap" label="Ẩn danh"
              header-align="center" width="100" align="center">
              <template #default="scope">
                <el-tag type="success" v-if="scope.row.bAnDanh == 1" size="small"><i class="fa fa-check"></i></el-tag>
                <el-tag type="danger" v-if="scope.row.bAnDanh == 0" size="small"><i class="fa fa-times"></i></el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="cHoVaTen" show-overflow-tooltip class="text-nowrap" label="Họ và tên">
            </el-table-column>
            <el-table-column prop="cSdt" show-overflow-tooltip class="text-nowrap" label="Số điện thoại" width="120">
            </el-table-column>
            <el-table-column prop="cDiaChi" show-overflow-tooltip class="text-nowrap" label="Địa chỉ">
            </el-table-column>
            <el-table-column prop="dNgayTao" label="Ngày tạo" align="center" width="120">
              <template #default="scope">
                {{ momentDate(scope.row.dNgayTao) }}
              </template>
            </el-table-column>
            <el-table-column prop="nTrangThai" label="Trạng thái" width="120" align="center">
              <template #default="scope">
                <el-tag type="primary" v-if="scope.row.nTrangThai == 1" size="small">Chưa phản hồi</el-tag>
                <el-tag type="success" v-if="scope.row.nTrangThai == 2" size="small">Đã phản hồi</el-tag>
                <el-tag type="danger" v-if="scope.row.nTrangThai == 0" size="small">Đã xóa</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="Hành động" align="center" width="150">
              <template #default="scope">
                <el-button plain type="success" :disabled="scope.row.nTrangThai == 0" v-if="scope.row.nTrangThai != 2"
                  data-bs-toggle="modal" data-bs-target="#modal_news" @click="handleOpenEdit(scope.row)">
                  <span class="btn-inner--icon"><i class="fas fa-check"></i></span>
                </el-button>
                <el-button plain type="primary" v-else :disabled="scope.row.nTrangThai == 0" data-bs-toggle="modal"
                  data-bs-target="#modal_news" @click="handleOpenEdit(scope.row)">
                  <span class="btn-inner--icon"><i class="fas fa-edit"></i></span>
                </el-button>
                <el-button plain type="danger" :disabled="scope.row.nTrangThai == 0"
                  v-loading.fullscreen.lock="isLoading" @click="handleDelete(scope.row)">
                  <span class="btn-inner--icon"><i class="fas fa-trash"></i></span>
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="col-12 py-2 pagination" style="justify-content: end">
        <el-pagination @size-change="handleChangePageSize" @current-change="handleChangePageNum"
          :current-page.sync="tableData.pageNum" :page-sizes="[5, 10, 20, 30, 40]" :page-size="tableData.pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="tableData.totalSize">
        </el-pagination>
      </div>
    </div>

    <div class="modal fade" id="modal_news" ref="newsModalRef" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered mw-1000px">
        <div class="modal-content">
          <!--begin::Modal header-->
          <div class="modal-header" id="modal_news_header">
            <!--begin::Modal title-->
            <h2 class="fw-bolder">{{ !operation ? "Thêm phản hồi" : "Cập nhật phản hồi" }}</h2>
            <div class="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal" @click="handleClose">
              <span class="svg-icon svg-icon-1">
                <inline-svg src="/media/icons/duotune/arrows/arr061.svg" />
              </span>
            </div>
            <!--end::Close-->
          </div>
          <!--end::Modal header-->
          <div class="modal-body mh-600px overflow-scroll">
            <el-form :model="formData" :rules="rules" ref="formDataRef" label-width="120px" class=" d-flex flex-column">
              <el-form-item v-if="formData.bAnDanh != 0" label="Ẩn danh:" prop="bAnDanh">
                <el-tag type="success" v-if="formData.bAnDanh == 1" size="small"><i class="fa fa-check"></i></el-tag>
              </el-form-item>
              <el-form-item v-if="formData.bAnDanh == 0" label="Họ và tên:" prop="cHoVaTen">
                <span>{{ formData.cHoVaTen }}</span>
              </el-form-item>
              <el-form-item v-if="formData.bAnDanh == 0" label="SĐT:" prop="cSdt">
                <span>{{ formData.cSdt }}</span>
              </el-form-item>
              <el-form-item v-if="formData.bAnDanh == 0" label="Địa chỉ:" prop="cDiaChi">
                <span>{{ formData.cDiaChi }}</span>
              </el-form-item>
              <el-form-item label="Địa điểm xảy ra:" prop="cDiaDiem">
                <span>{{ formData.cDiaDiem }}</span>
              </el-form-item>
              <el-form-item label="Đính kèm:" prop="cUrlDinhKem">
                <el-upload disabled action="#" list-type="picture-card" :auto-upload="false" placeholder="Chọn hình ảnh"
                  :on-preview="handlePictureCardPreview" ref="upload" :file-list="file" :on-change="handleChangeFile"
                  :on-remove="handleRemoveFile">
                  <template #file="{ file }">
                    <img v-if="isImage(file)" class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
                    <div v-else class="w-100 h-100 d-flex align-items-center justify-content-center flex-column"
                      :title='file.name.split("/")[file.name.split("/").length - 1]'>
                      <i class="el-icon-document"></i>
                    </div>
                    <span class="el-upload-list__item-actions"
                      :title='file.name.split("/")[file.name.split("/").length - 1]'>
                      <span v-if="isImage(file)" class="el-upload-list__item-preview"
                        @click="handlePictureCardPreview({ file: file, url: formData.cUrlDinhKem })">
                        <i class="el-icon-zoom-in fs-2"></i>
                      </span>
                      <span class="el-upload-list__item-download" @click="handleDownload(file)">
                        <i class="el-icon-download fs-2"></i>
                      </span>
                    </span>
                  </template>
                  <div class="d-flex align-items-center justify-content-center w-100 h-100">
                    <i class="el-icon-plus" v-if="file.length == 0"></i>
                    <i class="el-icon-refresh" v-if="file.length > 0"></i>
                  </div>
                </el-upload>
              </el-form-item>
              <el-form-item label="Nội dung" prop="cNoiDung">
                {{ formData.cNoiDung }}
              </el-form-item>
              <el-form-item label="Phản hồi" prop="cPhanHoi">
                <el-input type="textarea" v-model="formData.cPhanHoi" />
              </el-form-item>
            </el-form>
          </div>
          <div class="modal-footer">
            <div class="btn-group">
              <el-button plain v-if="!operation" type="primary" v-loading.fullscreen.lock="isLoading"
                @click="handleSave">Thêm</el-button>
              <el-button plain v-if="operation" type="primary" v-loading.fullscreen.lock="isLoading"
                @click="handleSave">Lưu</el-button>
              <el-button plain type="danger" @click="handleClose">Thoát</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog v-model="dialogVisible" class="bg-transparent w-auto shadow-none">
      <img class="mh-500px mw-1000px" :src="dialogFileUrl" alt="Preview Image" />
    </el-dialog>
  </div>
</template>
<script>
import { saveAs } from "file-saver";
import { Reporting } from "@/store/enums/StoreEnums";
import moment from "moment";
import { useStore } from "vuex";
import { hideModal } from "@/core/helpers/dom";
import { baseUrl } from "@/utils/global";
import '@vueup/vue-quill/dist/vue-quill.snow.css';
import { ElMessage } from "element-plus";
import JwtService from "@/core/services/JwtService";


export default {
  name: 'Reporting',

  data() {
    return {
      search: {
        cHoVaTen: "",
        cMoTa: "",
        nTrangThai: null,
      },
      pageRequest: {
        columnFilters: {},
        pageSize: 30,
        pageNum: 1
      },
      formData: {
        nMaBaiViet: null,
        cHoVaTen: "",
        cSdt: "",
        cDiaChi: "",
        cDiaDiem: "",
        cNoiDung: "",
        cPhanHoi: "",
        nTrangThai: 1,
        file: null
      },
      rules: {

        cPhanHoi: [{ required: true, message: "Xin vui lòng điền phản hồi", trigger: "blur" }],

      },
      tableData: {
        content: [{}]
      },
      isLoading: false,
      modalVisible: false,
      operation: false,
      iframeURL: "",
      openIframe: false,
      isSearchLoading: false,
      store: useStore(),
      dialogFileUrl: null,
      dialogVisible: false,
      file: [],
    }
  },
  methods: {
    handleChangePageNum(val) {
      this.pageRequest.pageNum = val
      this.handleFindPage()
    },
    handleChangePageSize(val) {
      this.pageRequest.pageSize = val
      this.handleFindPage()
    },
    handleOpenAdd() {
      this.$refs.formDataRef.resetFields()
      this.modalVisible = true
      this.operation = false
      this.formData = {}
    },
    handleOpenEdit(val) {
      this.$refs.formDataRef.resetFields()
      this.modalVisible = true
      this.operation = true
      this.file = []
      this.formData = Object.assign({}, val)
      if (val.cUrlDinhKem) {
        this.addFileFromURL(val.cUrlDinhKem)
      }

    },
    handleClose() {
      this.$refs.formDataRef.resetFields()
      this.modalVisible = false
      hideModal(this.$refs.newsModalRef)
    },
    handleDelete(val) {
      this.$confirm("Bạn có muốn xóa phản ánh hiện trường này không?", "Xác nhận", {
        confirmButtonText: "Xác nhận",
        cancelButtonText: "Hủy",
        type: "warning",
      })
        .then(() => {
          this.store.dispatch(Reporting.deleteReporting, val.nMaTinBaoToGiac).then(res => {
            if (res.code == 200) {
              ElMessage({ message: "Xóa phản ánh hiện trường thành công", type: "success" });
              this.handleFindPage()
            } else {
              ElMessage({ message: res.msg, type: "error" });
            }
          }).catch((error) => {
            ElMessage({ message: "Xóa phản ánh hiện trường thất bại", type: "error" });
          })
        }).catch(() => {

        })
    },
    handleFindPage() {
      this.pageRequest.columnFilters = {
        cHoVaTen: { value: this.search.cHoVaTen },
        nTrangThai: { value: this.search.nTrangThai },
      }
      this.store.dispatch(Reporting.findPageReporting, this.pageRequest).then(res => {
        if (res.code == 200) {
          this.tableData = res.data
        }
      }).catch((error) => {
        ElMessage({ message: "Tìm phản hồi thất bại", type: "error" });
      })
    },
    handleSave() {
      this.$refs.formDataRef.validate((valid) => {
        if (valid)
          this.$confirm("Bạn có muốn lưu phản hồi này không?", "Xác nhận", {
            confirmButtonText: "Xác nhận",
            cancelButtonText: "Hủy",
            type: "warning",
          }).then(() => {

            const formData = new FormData()
            formData.append("record", new Blob([JSON.stringify(this.formData)], { type: "application/json" }))
            if (this.operation) {
              this.store.dispatch(Reporting.saveReporting, this.formData).then(res => {
                if (res.code == 200) {
                  this.handleFindPage()
                  this.handleClose()
                  ElMessage({ message: "Cập nhật phản hồi thành công", type: "success" })
                } else {
                  ElMessage({ message: "Cập nhật phản hồi không thành công", type: "error" })
                }
              }).catch(() => {
                ElMessage({ message: "Cập nhật phản hồi không thành công", type: "error" })
              })
            } else {
              this.store.dispatch(Reporting.saveReporting, formData).then(res => {
                if (res.code == 200) {
                  this.handleFindPage()
                  this.handleClose()
                  ElMessage({ message: "Thêm phản hồi mới  thành công", type: "success" })
                } else {
                  ElMessage({ message: "Thêm phản hồi mới không thành công", type: "error" })
                }
              }).catch(() => {
                ElMessage({ message: "Thêm phản hồi mới không thành công", type: "error" })
              })
            }
          }).catch(() => {

          })
      })
    },
    handlePictureCardPreview(val) {
      this.dialogFileUrl = val.url
      this.dialogVisible = true
    },
    async handleChangeFile(file, File) {
      this.file = [file]
      this.formData.file = this.file
    },
    handleRemoveFile(file, File) {
      this.formData.file = []
      this.formData.file = this.file
    },
    addFileFromURL(url) {
      fetch(url, {
        headers: {
          'Authorization': `Bearer ${JwtService.getToken()}`
        }
      })
        .then(res => res.blob())
        .then(blob => {
          const urlParts = url.split('/');
          let fileName = urlParts[urlParts.length - 1].split('?')[0];
          if (!fileName || !fileName.includes('.')) {
            // Fallback if no valid file name
            const extension = blob.type.split('/')[1] || 'file';
            fileName = `downloaded_file.${extension}`;
          }

          const file = new File([blob], fileName, { type: blob.type });
          this.file.push({
            name: file.name,
            extension: file.name.split('.')[file.name.split('.').length - 1],
            url: URL.createObjectURL(file),
            status: 'success',
            uid: Date.now(),
            raw: file
          });
        })
        .catch(err => {
          console.error("Failed to fetch file:", err);
        });
    },
    handleDownload(file) {
      saveAs(file.raw, file.name);
    },
    isImage(file) {
      const imageTypes = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg'];
      const extension = file.name.split('.').pop().toLowerCase();
      return imageTypes.includes(extension);
    },
    momentDate(val) {
      return val ? moment(val).format("DD/MM/YYYY") : ""
    },
  },
  mounted() {
    this.handleFindPage()
  }
};
</script>
<style lang="scss">
.el-upload.is-disabled{
  display: none;
}
</style>